import neApi from './api';
import evaApi from './apiEvaluation'
import { requestCacheWrapper } from '../utils/common'
import store from '../store'

export default {
  // getworkplaceAnalysis: (params?: any) =>
  //   apiGet('/gateway/api/evaluation/getWorkplaceAnalysis', params),
  // getEvaluateAnalysis: (params?: any) =>
  //   apiGet('/gateway/api/evaluation/getEvaluateAnalysis', params),
  // getDevelopmentSuggestion: (params?: any) =>
  //   apiGet('/gateway/api/evaluation/getDevelopmentSuggestion', params),
  getworkplaceAnalysis: (params?: any) => {
    return neApi.get('/wx/app/evaluation/getWorkplaceAnalysis', params)
  },
  getEvaluateAnalysis: (params?: any) => {
    return neApi.get('/wx/app/evaluation/getEvaluateAnalysis', params)
  },
  getDevelopmentSuggestion: (params?: any) => {
    return neApi.get('/wx/app/evaluation/getDevelopmentSuggestion', params)
  },

  // 测评B-新
  findEvaluationInfo: async (params?: any) => {
    const { passportId } = store.state.userInfo || {}
    const tag = [ passportId, '/wx/app/evaluation/findEvaluationInfo', params.evaluationAlias]
    return requestCacheWrapper(async (saveCache: any) => {
      const res: any = await evaApi.get('/wx/app/evaluation/findEvaluationInfo', params)
      if (res && res.code === 0) {
        saveCache(res)
      }
      return res
    }, tag, 7)
  },
  findEvaluationAnalysis: (params?: any) => {
    const { passportId } = store.state.userInfo || {}
    const tag = [ passportId, '/wx/app/evaluation/findEvaluationAnalysis', params.evaluationAlias]
    return requestCacheWrapper(async (saveCache: any) => {
      const res: any = await evaApi.get('/wx/app/evaluation/findEvaluationAnalysis', params)
      if (res && res.code === 0) {
        saveCache(res)
      }
      return res
    }, tag, 7)
  },
  findDevelopmentSuggestions: (params?: any) => {
    const { passportId } = store.state.userInfo || {}
    const tag = [ passportId, '/wx/app/evaluation/findDevelopmentSuggestions', params.evaluationAlias]
    return requestCacheWrapper(async (saveCache: any) => {
      const res: any = await evaApi.get('/wx/app/evaluation/findDevelopmentSuggestions', params)
      if (res && res.code === 0) {
        saveCache(res)
      }
      return res
    }, tag, 7)
  }
};
